// @need-translate
import range from 'lodash/range';
import {RefObject, useEffect, useRef, useState} from 'react';
import {tt} from '../../../common/getTranslations';
import {useAdjustXAxisScrollPosition} from '../../../common/shared/hooks/useAdjustXAsixScrollPosition';
import {useWindowInnerWidth} from '../../../common/shared/hooks/useWindowInnerWidth';
import {twMerge} from '../../../common/twMerge';
import {CONTENT_HOME_UPPER_TAB_HEIGHT} from '../../../domain/content/[seriesId]/constant';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Text} from '../../atoms/Text/Text';
import {ContentHomeUpperTabItem} from './ContentHomeUpperTabItem';
import {ContentHomeUpperTabProps} from './ContentHomeUpperTabProps.interface';

export function ContentHomeUpperTab({
  isMobile,
  tabItems,
  currentTabItemId,
  onClickTab,
  className,
  ...props
}: ContentHomeUpperTabProps) {
  const {tabRef, onSelectTabItem} = useAdjustXAxisScrollPosition(
    tabItems?.findIndex(item => item.id === currentTabItemId)
  );

  const upperTabRef = useRef<HTMLDivElement | null>(null);

  const [shouldLeftAlign, setShouldLeftAlign] = useState(false);
  const width = useWindowInnerWidth();
  // 탭이 화면보다 크면 왼쪽 정렬하는걸로 디자인에서 가이드됨
  useEffect(() => {
    if (!upperTabRef.current?.children?.length) {
      return;
    }
    const tabWidth = range(upperTabRef.current.children.length).reduce(
      (acc, cur) => {
        return acc + (upperTabRef.current?.children[cur].scrollWidth || 0);
      },
      0
    );
    const isBiggerThanWindow = tabWidth > width;
    setShouldLeftAlign(isBiggerThanWindow);
  }, [tabRef, width]);

  if (!tabItems) {
    return null;
  }

  return (
    <div
      className={twMerge(
        'relative flex w-full bg-theme-bg-base',
        isMobile &&
          'before:absolute before:bottom-0 before:left-0 before:z-[-1] before:h-45pxr before:w-full before:bg-theme-bg-base',
        className
      )}
      style={{
        height: CONTENT_HOME_UPPER_TAB_HEIGHT,
      }}
      {...props}
    >
      <div
        ref={
          shouldLeftAlign ? (tabRef as RefObject<HTMLDivElement>) : undefined
        }
        className={twMerge(
          'flex h-full w-full',
          'overflow-x-scroll px-4pxr scrollbar-hide',
          shouldLeftAlign ? 'justify-start' : 'justify-center'
        )}
      >
        {tabItems.map((tabItem, index) => {
          const isSelected = currentTabItemId === tabItem.id;
          return (
            <div
              key={tabItem.id}
              className={twMerge(
                'relative flex items-center justify-center',
                'shrink-0'
              )}
              {...putTiaraObjectProps({
                click: {
                  layer1: '서브탭',
                  copy: tabItem.text,
                },
              })}
            >
              <ContentHomeUpperTabItem
                href={tabItem.href}
                isActive={isSelected}
                hasNewIcon={tabItem.hasNewIcon}
                onClick={e => {
                  onSelectTabItem(e.target as HTMLElement);
                  LOG_CLICK_EVENT(
                    '서브탭_클릭',
                    e,
                    onClickTab ? () => onClickTab(tabItem.id, e) : undefined
                  );
                }}
              >
                {isSelected && <Text className="blind">선택됨, </Text>}
                {tt(tabItem)}
                <Text className="blind">
                  탭, {`총 ${tabItems.length}개 중 ${index + 1}번째`}
                </Text>
              </ContentHomeUpperTabItem>
            </div>
          );
        })}
      </div>
    </div>
  );
}
